import { css } from 'styled-components';

/** Light pastel pills (bg-50 / text-700 / border-200) re-tinted from their text hue on dark. */
export const darkPastel = text => css`
  html.dark & {
    color: color-mix(in srgb, ${text} 50%, white);
    background: color-mix(in srgb, ${text} 16%, transparent);
    border-color: color-mix(in srgb, ${text} 34%, transparent);
  }
`;
